import React, { useEffect } from "react";
import WOW from "wowjs";
import "animate.css/animate.min.css";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Summary from "./components/Summary";
import Experience from "./components/Experience";
import data from "./data/data.json";
import { totalExperienceYears } from "./utils/duration";
import Footer from "./components/Footer";
import "./styles/MainContent.css";
import "./styles/App.css";

const App = () => {
  // Single WOW instance reveals every `.wow` element on the page once.
  useEffect(() => {
    new WOW.WOW().init();
  }, []);

  // Stats that must never go stale are derived from the experience dates.
  const years = totalExperienceYears(data.experience);
  const derived = {
    yearsExperience: years == null ? null : `${String(years).padStart(2, "0")}+`,
  };

  return (
    <div className="app-container">
      <Navbar nav={data.nav} initials={data.about.initials} />
      <main className="main-content">
        <div className="content-section">
          <About about={data.about} />
          <Summary summary={data.summary} section={data.sections.summary} derived={derived} />
        </div>
        <div className="content-section">
          <Experience experience={data.experience} section={data.sections.experience} />
        </div>
        <div className="content-section">
          <Skills skills={data.skills} section={data.sections.skills} />
        </div>
        <div className="content-section">
          <Projects projects={data.projects} section={data.sections.projects} />
        </div>
      </main>
      <Footer about={data.about} nav={data.nav} />
    </div>
  );
};

export default App;
